



























import {Component, Vue} from 'vue-property-decorator'

// noinspection TypeScriptCheckImport
import VGanttChart from '@/../node_modules/v-gantt-chart/src/gantt.vue'
import kepler from "../../lib/kepler_sdk/kepler";

@Component({
  components: {
    VGanttChart,
  },
})
export default class Home extends Vue {
  public gantt: any = {
    startTime: "2020-04-24 00:00:00",
    endTime: "2020-04-26 00:00:00",
    timeLines: [
      //{
      //  time: "2020-04-23 04:10:00",
      //  color: "#c2c2c2"
      //}
    ],
    datas: [],
    datasEX: [
      {
        id: 'test', // not necessary
        gtArray: [ // The default array to be rendered
          {
            name: 'test', // not necessary
            start: '2020-04-23 00:00:00',
            end: '2020-04-23 04:10:00',
          },
          {
            id: 'test2', // not necessary
            start: '2020-04-23 05:00:00',
            end: '2020-04-23 12:04:00',
          },
        ],
      },
      {
        id: 'test2', // not necessary
        gtArray: [ // The default array to be rendered
          {
            name: 'test', // not necessary
            start: '2020-04-23 08:00:00',
            end: '2020-04-23 10:10:00',
          },
        ],
      },
    ],
  }

  public dumpShit(shit: any) {
    alert(JSON.stringify(shit, undefined, 2))
  }

  public clickReservation(res: any) {
    this.setTimelines(res.start, res.end)
  }

  public setTimelines(start: any = null, end: any = null) {
    this.gantt.timeLines = [
      {
        time: (new Date()).toISOString(),
        color: "#c2c2c2"
      }
    ]

    if (start) {
      this.gantt.timeLines.push(
        {
          time: start,
          color: "green"
        }
      )
    }

    if (end) {
      this.gantt.timeLines.push(
        {
          time: end,
          color: "red"
        }
      )
    }
  }

  public mounted() {
    this.setTimelines()

    let datas: any = []
    kepler.get('reservations', {
      itemsPerPage: 100,
      page: 1,
      from: this.gantt.startTime,
      to: this.gantt.endTime,
    })!.then((d) => {
      d.data.items.forEach((res: any) => {
        if (datas[res.vehicle.plate] == undefined) {
          datas[res.vehicle.plate] = {
            id: res.vehicle.plate,
            booking_mode: res.booking_mode,
            vehicle: res.vehicle,
            gtArray: []
          }
        }
        if (res.status != "CANCELLED") {
          datas[res.vehicle.plate].gtArray.push(res)
        }
      })
      this.gantt.datas = Object.values(datas)
    })
  }
}
